import "./slider-logo-partner";
import "./slider-hero";
